// import React from "react";
// const RegistrationSucess = () => {
//   return (
//     <div>
//       <h1>Signup Successful!</h1>
//       <p>Your account has been created successfully.</p>
//     </div>
//   );
// };

// export default RegistrationSucess;

import React from "react";
import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { customButtonStyles } from "../../common/commonStyles";

const RegistrationSuccess = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f7fa",
        p: 2,
      }}
    >
      <Card
        sx={{
          maxWidth: 400,
          width: "100%",
          textAlign: "center",
          boxShadow: 1,
          borderRadius: 3,
          p: 1,
        }}
      >
        <CardContent>
          <Typography variant="h6" gutterBottom sx={{ color: "green" }}>
            🎯 Account Created Successfully!
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Your account has been created successfully. Please proceed to login
            and start using the application.
          </Typography>

          <Button
            variant="contained"
            fullWidth
            sx={customButtonStyles}
            onClick={() => navigate("/login")}
          >
            Go to Login
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default RegistrationSuccess;
